<template>
  <!-- 货品信息 -->
  <div class="goodsList">
    111
  </div>
</template>

<script>

export default {
  name: "shopGoods",
  props: {},
  data() {
    return {
     
    };
  },
  methods: {
   
  }
};
</script>

<style lang="scss" scoped>
.hideContent {
  width: 200px;
  display: block;
  overflow: hidden;
  word-break: keep-all;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.goodsList {
  display: flex;
  flex-direction: row;
  overflow: hidden;
  height: 100%;
  &__left {
    margin: 20px;
    width: 20%;
    min-width: 20%;
    overflow: auto;
  }
  &__right {
    flex: 1;
  }
}
</style>

<style lang="scss">
.custom-empty {
  background-color: #f7f7f7;
  width: 61px;
  height: 38px;
}
.image-slot {
  padding-left: 25px;
  padding-top: 11px;
}
.custom-cas-goods-list .el-input.is-disabled .el-input__inner {
  background-color: #ffffff;
  color: #001528;
  border: 0px;
  padding: 0px;
  height: 25px;
}
</style>
